import React from "react"
import { Link } from "react-router-dom"
import { Button, Container } from "reactstrap"
import comingSoon from "../../assets/images/coming-soon.svg"

const ComingSoon = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <div
          className={
            "py-5 d-flex flex-column align-items-center justify-content-between"
          }
        >
          <img
            src={comingSoon}
            style={{
              maxWidth: "300px",
            }}
            alt="Record not found"
          />
          <h4
            style={{
              color: "#000000",
              fontSize: "32px",
              fontWeight: "600",
              marginTop: "15px",
              marginBottom: "5px",
            }}
          >
            {`Coming Soon`}
          </h4>
          <p
            style={{
              color: "#000000",
              fontSize: "16px",
            }}
          >
            {`The page you're looking for will coming soon`}
          </p>

          <div className="buttons">
            <Link to={"/dashboard"}>
              <Button type="button" className="primary">
                Return to Dashboard
              </Button>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default ComingSoon
